import React from 'react'
import { chemicalStocksCreateApi, chemicalStocksDeleteApi, chemicalStocksGetApi, chemicalStocksUpdateApi } from '../../../../services/api'
import { deleteDataFromApi, getDataFromApi, postDataFromApi } from '../../../../services/commonServices';
import { toast } from 'react-toastify';
import { handleCalibrationCreateUpdate } from '../Purchase/Calibration/CalibrationHandler';

export const getChemicalStock = async (chemicalStockId, setformData, status, setIsOverlayLoader) => {
    function formatValue(value) {
        if (!value) return value
        const num = Number(value);
        if ((num * 100) % 1 !== 0) {
            return num.toString().replace(/\.?0+$/, "");
        }
        return num.toFixed(2);
    }
    try {
        const getChemicalStocks = chemicalStocksGetApi(chemicalStockId)
        let res;
        res = await getDataFromApi(getChemicalStocks)
        if (res.data.status === 200) {


            setformData((previousData) => {
                return {
                    0: {
                        ...previousData,
                        ...res?.data?.data,
                        ...res?.data?.data?.calibration_details,
                        stock_minimum_qty: formatValue(res?.data?.data?.stock_minimum_qty),
                        fk_item_id: status === "View" ? res?.data?.data?.item_details?.item_rm_code : res?.data?.data.fk_item_id,
                        item_rate: res?.data?.data?.item_details?.item_rate,
                        stock_fk_lab_id: status === "View" ? res?.data?.data?.lab_details ? res?.data?.data?.lab_details?.lab_name + `(${res?.data?.data?.lab_details?.lab_code})` : '' : res?.data?.data.fk_lab_id,

                        stock_fk_branch_id: status === "View" ? res?.data?.data?.branch_details ? res?.data?.data?.branch_details?.br_name + `(${res?.data?.data?.branch_details?.br_code})` : '' : res?.data?.data.fk_branch_id,
                        fk_company_id: status === "View" ? res?.data?.data?.company_details ? res?.data?.data?.company_details?.cmp_name : '' : res?.data?.data.fk_company_id,
                        fk_department_id: status === "View" ? res?.data?.data?.department_details ? res?.data?.data?.department_details?.dept_name : '' : res?.data?.data.fk_department_id,
                        stock_is_branch_record: true
                    }
                }
            })

        }
        else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    } catch (error) {
        // console.log('errrr', error)
    }
}

export const handleChemicalStocksCreateAndUpdate = async (formData, handleSubmit, setIsOverlayLoader,
    navigate,
    status) => {
    try {

        let isValidate = handleSubmit();
        if (!isValidate) {
            return false;
        }
        const stockFields = [
            // "stock_opening_qty",
            // "stock_purchase_qty",
            // "stock_minimum_qty",
        ];

        const hasInvalidStockQty = stockFields.some(
            (key) => Number(formData[0]?.[key]) <= 0
        );

        if (hasInvalidStockQty) {
            toast.error("Stock quantity must be greater than 0", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }

        const payload = {
            fk_item_id: formData[0]?.fk_item_id,
            stock_name_of_chemical: formData[0]?.stock_name_of_chemical,
            stock_opening_qty: formData[0]?.stock_opening_qty,
            stock_purchase_qty: formData[0]?.stock_purchase_qty,
            stock_consumed_qty: formData[0]?.stock_consumed_qty,
            stock_closing_qty: formData[0]?.stock_closing_qty,
            stock_remark: formData[0]?.stock_remark,
            stock_services: formData[0]?.stock_services,
            // fk_stock_calibration_id: formData[0]?.fk_calibration_id,
            stock_expiry_date: formData[0]?.stock_expiry_date,
            stock_notify_expiry_date: formData[0]?.stock_notify_expiry_date,
            fk_lab_id: formData[0]?.stock_fk_lab_id,
            fk_branch_id: formData[0]?.stock_fk_branch_id,
            // stock_is_branch_record: formData[0]?.stock_is_branch_record,
            stock_is_branch_record: true,
            stock_buffer_value: formData[0]?.stock_buffer_value,
            stock_is_show_notification: formData[0]?.stock_is_show_notification,
            stock_minimum_qty: formData[0]?.stock_minimum_qty,
            fk_company_id: formData[0]?.fk_company_id,
            fk_department_id: formData[0]?.fk_department_id,
            fk_category_id: formData[0]?.fk_category_id,
            stock_avg_usage: formData[0]?.stock_avg_usage,
            stock_daily_usage: formData[0]?.stock_daily_usage,
            stock_per_day: formData[0]?.stock_per_day,
            stock_status: status
        }
        if ([formData[0]?.stock_services].includes('Calibration')) {

            await handleCalibrationCreateUpdate(formData, handleSubmit, setIsOverlayLoader, null, 1, '', null, null, null, 1, (calibID) => {
                if (calibID) {
                    payload.fk_stock_calibration_id = calibID
                }
            })
            if (!payload.fk_stock_calibration_id) {
                return
            }
        }

        let res;
        if (formData[0]?.chemist_stock_id) {
            let updateChemicalStock = chemicalStocksUpdateApi(formData[0]?.chemist_stock_id)
            res = await postDataFromApi(updateChemicalStock, payload)

        } else {

            res = await postDataFromApi(chemicalStocksCreateApi, payload);

        }

        if (res?.data?.status === 200) {

            toast.success(res?.data?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            navigate("/chemicalStocks")

        } else {
            setIsOverlayLoader(false)
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }

    } catch (error) {
        // console.log('errrr', error)
    }
}

export const handleChemicalStocksDelete = async (
    tenderId,
    setIsDelete,
    getAllListingData,
    setPopupIndex

) => {
    try {
        let tenderDelete = chemicalStocksDeleteApi(tenderId)
        let res = await deleteDataFromApi(tenderDelete);
        if (res?.data?.status === 200) {
            toast.success(res.data.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            getAllListingData();
        } else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }
    catch (ex) { }
    finally {
        setIsDelete(false);
        setPopupIndex(-1);
    }


}

